module.exports = __webpack_public_path__ + "img/soccerboard19.9340fa27.jpg";